import axiosInstance from "../api/axiosInstance";

export type ResetDemoResponse = {
  success: boolean;
  patients: number;
  generation: number;
};

/** Demo mode: clear what this presenter made and seed a fresh demo day. */
export const resetDemo = () => axiosInstance.post<ResetDemoResponse>("/demo-ehr/reset/");
